import axiosClient from "api/axiosClient";

const BASE_URL = "/Report";

const buildUrl = (reportName, pathParams = [], format = "pdf") => {
    const encodedParams = pathParams
        .filter(
            (value) => value !== null && value !== undefined && value !== ""
        )
        .map((value) => encodeURIComponent(value));

    return [BASE_URL, reportName, ...encodedParams, format].join("/");
};

const reportService = {
    get(reportName, options = {}) {
        const { pathParams = [], params, format = "pdf" } = options;

        const url = buildUrl(reportName, pathParams, format);

        return axiosClient.get(url, {
            params,
            responseType: "blob"
        });
    },

    async getPdfUrl(reportName, options = {}) {
        const response = await this.get(reportName, {
            ...options,
            format: "pdf"
        });

        const blob = new Blob([response.data], {
            type: "application/pdf"
        });

        return URL.createObjectURL(blob);
    },

    async openPdf(reportName, options = {}) {
        const url = await this.getPdfUrl(reportName, options);

        window.open(url, "_blank");

        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 60000);
    }
};

export default reportService;
